import { render, staticRenderFns } from "./Detail_Dashboard.vue?vue&type=template&id=5378dda2&scoped=true"
import script from "./Detail_Dashboard.vue?vue&type=script&lang=js"
export * from "./Detail_Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378dda2",
  null
  
)

export default component.exports